import { TempLesson } from '@/models/Lesson';
import { TempLessonBlock } from '@/models/_deprecated/LessonBlock';

export const shouldDisplayDirectLessons = (
  directLessons: TempLesson[] = [],
  _blocks: TempLessonBlock[] = [],
) => {
  return directLessons && directLessons.length > 0;
};
